var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.40002C6.6983 2.40002 2.3999 6.69842 2.3999 12C2.3999 17.3016 6.6983 21.6 11.9999 21.6C17.3015 21.6 21.5999 17.3016 21.5999 12C21.5999 6.69842 17.3015 2.40002 11.9999 2.40002ZM17.6483 9.64923L11.2487 16.0488C11.0231 16.2744 10.7195 16.4004 10.4003 16.4004C10.0811 16.4004 9.7763 16.2744 9.5519 16.0488L6.3515 12.8484C5.8823 12.3792 5.8823 11.6208 6.3515 11.1516C6.8207 10.6824 7.5791 10.6824 8.0483 11.1516L10.4003 13.5036L15.9515 7.95242C16.4207 7.48322 17.1791 7.48322 17.6483 7.95242C18.1175 8.42162 18.1175 9.18003 17.6483 9.64923Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.f6958bce8bc48657c867bc18152aa8d2.svg";
export { ForwardRef as ReactComponent };